import { StateModel } from '../../shared/models/default-state.model';
import {
  GET_TOPIC_STATISTICS_REQUEST,
  GET_TOPIC_STATISTICS_SUCCESS,
  GET_TOPIC_STATISTICS_ERROR,
  EXPORT_TOPIC_STATISTICS_REQUEST,
  EXPORT_TOPIC_STATISTICS_SUCCESS,
  EXPORT_TOPIC_STATISTICS_ERROR,
} from '../actions/topic-statistics.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: [],
};

export const topicStatisticsReducer = (state: StateModel = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case GET_TOPIC_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case GET_TOPIC_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
      };

    case GET_TOPIC_STATISTICS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export const exportTopicStatisticsReducer = (state: StateModel = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case EXPORT_TOPIC_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case EXPORT_TOPIC_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
      };

    case EXPORT_TOPIC_STATISTICS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    default:
      return state;
  }
};
